import { Theme } from '@mui/material';

export const menuItemStyles = (theme: Theme) => ({
  MuiMenuItem: {
    styleOverrides: {
      root: {
        height: 20,
        '&:hover': {
          backgroundColor: theme.palette.action.hover,
        },
      },
    },
  },
});
